import React, { useContext } from "react"
import { Dimensions, TouchableOpacity, useWindowDimensions, View } from "react-native"
import TextM from "@common/components/text/TextM"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { Tooltip } from "react-native-paper"
import { theme } from "@common/theme/theme"
import { hasRole } from "@data/utility/ability"
import { connect } from "react-redux"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { useSafeAreaFrame } from "react-native-safe-area-context"

const CONNECTION_MESSAGES = {
    local: "Connexion faible. Déplace-toi.",
    remoteSingle: (name) => `La connexion de ${name} est faible`,
    remoteMultiple: (names) => `Les connexions de ${names} sont faibles`,
};

const ConnectionQualityAlert = (props) => {

    const { miniMode, user, participants, poorConnectionQualityIds, isLocalPoorConnection, currentLiveSession } = props

    const dimensions = useWindowDimensions()

    const liveParticipants = currentLiveSession?.users?.filter(p => p.id !== user.id)?.filter(p => participants?.includes(p.id)) || [];

    // Read the debounced flag from Redux so the banner only appears once the
    // 15s debounce in LKEvents has elapsed — direct LiveKit hooks are too
    // twitchy and produce false positives.
    const isLocalPoor = !!isLocalPoorConnection;
    const isTutor = hasRole(user, "tutor");
    const poorRemoteParticipants = isTutor
         ? liveParticipants?.filter(p => poorConnectionQualityIds.includes(p.id))
         : [];

    if (!isLocalPoor && poorRemoteParticipants.length === 0) return null;

    const getStudentNames = () => {
        return poorRemoteParticipants
            .map(p => p.display_name)
            .filter(Boolean)
            .join(', ');
    };

    const getMessages = () => {
        const messages = [];
        if (isLocalPoor) {
            messages.push(CONNECTION_MESSAGES.local);
        }
        if (poorRemoteParticipants.length > 0) {
            const names = getStudentNames();
            messages.push(
                poorRemoteParticipants.length === 1 
                    ? CONNECTION_MESSAGES.remoteSingle(names)
                    : CONNECTION_MESSAGES.remoteMultiple(names)
            );
        }
        return messages;
    };

    const renderFullAlert = (miniMode = false) => (
        <View style={{
            position: 'absolute',
            top: 0,
            left:  miniMode ? 0 : null,
            backgroundColor: theme.colors.blackTransparent2,
            paddingVertical: 5,
            paddingHorizontal: 10,
            flexDirection: 'row',
            alignItems: 'center',
            alignSelf: 'center',
            borderBottomEndRadius: 10,
            borderBottomStartRadius: 10,
            justifyContent: miniMode ? null : 'center',
            width: miniMode ? 200 : "60%",
        }}>
            <FontAwesome5 
                name="exclamation-triangle" 
                size={miniMode ? 13 : 16}
                color={theme.colors.accentDark}
                style={{ marginRight: miniMode ? 5 : 10 }}
            />
            {<View>
                {getMessages().map((message, index) => (
                    <TextM 
                        key={index}
                        color={theme.colors.white}
                        fontSize={miniMode ? 8 : 12}
                        style={{ marginBottom: index < getMessages().length - 1 ? 5 : 0, width: miniMode ? 200 : null }}
                    >
                        {message}
                    </TextM>
                ))}
            </View>}
        </View>
    );

    const renderMiniAlert = () => (
        <View style={{
            position: 'absolute',
            top: 10,
            left: 10,
            zIndex: 1000,
            backgroundColor: theme.colors.blackTransparent,
            padding: 5,
            borderRadius: 5,
        }}>
        <Tooltip
            title={getMessages().join('\n')}
            enterTouchDelay={0}
            leaveTouchDelay={0}
        >
            <TouchableOpacity
            >
                <FontAwesome5 
                    name="exclamation-triangle" 
                    size={16} 
                    color={theme.colors.accentDark}
                />
            </TouchableOpacity>
        </Tooltip>
        </View>
    );

    return renderFullAlert(miniMode);
};

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        participants: state.liveMode?.liveParticipants,
        poorConnectionQualityIds: state.liveMode?.poorConnectionQualityIds || [],
        isLocalPoorConnection: state.liveMode?.isLocalPoorConnection || false,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(x => x?.id === state.liveMode?.liveSessionId),
    };
};

export default connect(mapStateToProps)(ConnectionQualityAlert); 